import { render, staticRenderFns } from "./TablePercentageBar.vue?vue&type=template&id=40b63818&"
import script from "./TablePercentageBar.vue?vue&type=script&lang=js&"
export * from "./TablePercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./TablePercentageBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports